import React, { useContext, useEffect } from 'react';
import MeuConsumptionContext from '../../../../contexts/MeuConsumptionContext';
import { MeuConsumptionContainer } from '../styles';
import MeuConsumptionConsolidatedInformations from './MeuConsumptionConsolidatedInformations';
import MeuConsumptionMonthlyUsage from './MeuConsumptionMonthlyUsage';
import MeuConsumptionDailyUsage from './MeuConsumptionDailyUsage';

const MeuConsumptionSummaryComponent: React.FC = () => {
  const { tenant, content, setHeaderContent } = useContext(MeuConsumptionContext);

  useEffect(() => {
    setHeaderContent({
      redirect: '/data-consumption',
      text: content.formatString(content.header, tenant.info.name),
    });
    return () => setHeaderContent({ redirect: null });
  }, []);

  return (
    <MeuConsumptionContainer>
      <MeuConsumptionConsolidatedInformations></MeuConsumptionConsolidatedInformations>
      <MeuConsumptionMonthlyUsage />
      <MeuConsumptionDailyUsage />
    </MeuConsumptionContainer>
  );
};

export default MeuConsumptionSummaryComponent;
